import { render, staticRenderFns } from "./ModalEnviarColaboracaoOuNoticiaParaPasta.vue?vue&type=template&id=4d97fc85&scoped=true"
import script from "./ModalEnviarColaboracaoOuNoticiaParaPasta.vue?vue&type=script&lang=js"
export * from "./ModalEnviarColaboracaoOuNoticiaParaPasta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d97fc85",
  null
  
)

export default component.exports